<div style="margin: 15px; padding-bottom: 100px;">
	<div style="padding: 8px">
		<h1>
			<i class="fa fa-cogs" aria-hidden="true"></i> INFRASTRUCTURE
		</h1>
	</div>
	<div class="row">
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureServerObjectsPage)" class="col-sm-3" [routerLink]="['server-objects']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-circle-o fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">SERVER OBJECTS</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureDevicesPage)" class="col-sm-3" [routerLink]="['devices']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-microchip fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">DEVICES</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureDriverObjectsPage)" class="col-sm-3" [routerLink]="['driver-objects']">
		    <div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
		                <i class="fa fa-file-code-o fa-4x" aria-hidden="true" style="color: #f57300"></i>
		                <h3 style="overflow: hidden">DRIVER OBJECTS</h3>
		                <h4 style="overflow: hidden"></h4>
		            </div>
		        </div>
		    </div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureServicesPage)" class="col-sm-3" [routerLink]="['services']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-handshake-o fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">SERVICES</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureAssetsPage)" class="col-sm-3" [routerLink]="['efassets']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-star-o fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">ASSETS</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
    <div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructurePeoplePage)" class="col-sm-3" [routerLink]="['people']" >
      <div class="panel panel-drk-ornge edgefinityButton">
        <div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
          <div class="panel-body" style="min-height: 190px; max-height: 100%">
            <i class="fa fa-users fa-4x" aria-hidden="true" style="color: #f57300"></i>
            <h3 style="overflow: hidden">PEOPLE</h3>
            <h4 style="overflow: hidden"></h4>
          </div>
        </div>
      </div>
    </div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureReadersPage)" class="col-sm-3" [routerLink]="['readers']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-square-o fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">READERS</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureAntennasPage)" class="col-sm-3" [routerLink]="['antennas']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-feed fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">ANTENNAS</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureRfidEncodingSchemesPage)" class="col-sm-3" [routerLink]="['rfid-encoding-schemes']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-microchip fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">RFID ENCODING SCHEMES</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureTagsPage)" class="col-sm-3" [routerLink]="['tags']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-tag fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">TAGS</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureLocationsPage)" class="col-sm-3" [routerLink]="['locations']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-map fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">LOCATIONS</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.InfrastructureZonesPage)" class="col-sm-3" [routerLink]="['zones']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-bullseye fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">ZONES</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.DataMappingPage)" class="col-sm-3" [routerLink]="['data-mapping-sets']" >
			<div class="panel panel-drk-ornge edgefinityButton">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<div class="panel-body" style="min-height: 190px; max-height: 100%">
						<i class="fa fa-bullseye fa-4x" aria-hidden="true" style="color: #f57300"></i>
						<h3 style="overflow: hidden">DATA MAPPING SET</h3>
						<h4 style="overflow: hidden"></h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
